module.exports = __webpack_public_path__ + "static/img/home.bece8c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/header/home.png
// module id = 9EcW
// module chunks = 7